import { useCallback, useEffect } from 'react';

import { checkPropertyExplorerPublishStatus } from '~/helpers/checkPublishStatus';
import { PropertyExplorerProjectData } from '~/queries/getPropertyExplorerProjectData';

export const useCleanup = (data?: PropertyExplorerProjectData) => {
  const callback = useCallback(() => {
    window.parent.postMessage('module-cleanup', '*');
  }, []);

  useEffect(() => {
    const isPublished = data && checkPropertyExplorerPublishStatus(data);

    if (data && !isPublished) {
      callback();
    }
  }, [data, callback]);

  useEffect(() => {
    window.addEventListener('beforeunload', callback);

    return () => window.removeEventListener('beforeunload', callback);
  }, [callback]);
};
